module.exports = __webpack_public_path__ + "img/202208.0a22eacd.png";